// Storage helpers for the SUPERADMIN "all companies vs one company" switcher.
// Independent of resellerCompany.ts — different user type, different default: there
// is no "home workspace" for SUPERADMIN to fall back to, so absence of a stored scope
// means "All Companies", not "my own data".

export interface Company {
  tenantId: number;
  name: string;
}

export type SuperAdminCompanyScope =
  | { mode: 'all' }
  | { mode: 'single'; company: Company };

const STORAGE_KEY = 'superAdminCompanyScope';

export const getSuperAdminScope = (): SuperAdminCompanyScope => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { mode: 'all' };
    const parsed = JSON.parse(raw);
    if (parsed?.mode === 'single' && parsed.company && typeof parsed.company.tenantId === 'number') {
      return parsed as SuperAdminCompanyScope;
    }
    return { mode: 'all' };
  } catch {
    return { mode: 'all' };
  }
};

export const storeSuperAdminScope = (scope: SuperAdminCompanyScope): void => {
  if (scope.mode === 'all') {
    localStorage.removeItem(STORAGE_KEY);
  } else {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(scope));
  }
};

export const clearSuperAdminScope = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};

// Used by api.ts's request interceptor (outside React context) to decide whether to
// attach x-impersonate-tenant-id. Returns null in "all" mode.
export const getSuperAdminSingleCompany = (): Company | null => {
  const scope = getSuperAdminScope();
  return scope.mode === 'single' ? scope.company : null;
};
